<template>
  <v-row style="border-top: 2px solid grey; border-bottom: 2px solid grey">
    <v-col cols="12" class="text-center my-0 py-0" v-if="!readonly">
      <p class="mt-2 text-h5">{{ title || "Incluir / Excluir" }}</p>
    </v-col>
    <v-col cols="12" class="my-0 py-0" v-if="!readonly">
      <slot name="search"></slot>
    </v-col>
    <v-col
      v-if="!readonly && (bigList && (list_from.length > 0 || list_to.length > 0))"
      cols="4"
      class="text-left my-0 py-0"
    >
    </v-col>
    <v-col
      v-if="!readonly && (bigList && (list_from.length > 0 || list_to.length > 0))"
      cols="4"
      class="text-center my-0 py-0"
    >
      <v-btn :disabled="loading" @click="addAll()" variant="text" color="blue"
        ><v-icon class="mr-2">mdi-table-arrow-right</v-icon> Adicionar
        todos</v-btn
      >
      <v-btn :disabled="loading" @click="removeAll()" variant="text" color="error"
        ><v-icon class="mr-2">mdi-backspace</v-icon> Remover todos</v-btn
      >
    </v-col>
    <v-col
      v-if="!readonly && (bigList && (list_from.length > 0 || list_to.length > 0))"
      cols="4"
      class="text-right my-0 py-0"
    >
      <v-btn :disabled="loading" @click="$emit('updated', list_to)" variant="text" color="success"
        ><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn
      >
    </v-col>
    <v-col cols="6" class="pa-0" v-if="!readonly">
      <v-list lines="one" class="border ma-3 pa-0">
        <v-hover
          v-for="(item, ix) in list_from"
          :key="ix"
          v-slot="{ isHovering, props }"
        >
          <v-list-item v-bind="props" @click="addItem(item, ix)" class="py-0">
            <div v-if="isHovering" style="height: 100%">
              <v-icon class="mr-2">mdi-arrow-right</v-icon>
              {{ item[listFromKey] }}
            </div>
            <div v-else style="height: 100%">
              {{ item[listFromKey] }}
            </div>
          </v-list-item>
        </v-hover>
      </v-list>
    </v-col>
    <v-col :cols="readonly ? 12 : 6" class="pa-0">
      <v-list lines="one" class="border ma-3 pa-0">
        <v-hover
          v-for="(item, ix) in list_to"
          :key="ix"
          v-slot="{ isHovering, props }"
        >
          <v-list-item
            v-bind="props"
            @click="removeItem(item, ix)"
            :class="['py-0', `${item.from_to_color ? `text-${item.from_to_color}` : ''}`]"
          >
            <div v-if="!readonly && isHovering" style="height: 100%">
              <v-icon class="mr-2">mdi-delete</v-icon> {{ item[listToKey] }}
            </div>
            <div v-else style="height: 100%">
              {{ item[listToKey] }}
            </div>
          </v-list-item>
        </v-hover>
      </v-list>
    </v-col>
    <v-col cols="4" class="text-left my-0 py-0" v-if="!readonly"> </v-col>
    <v-col cols="4" class="text-center my-0 py-0" v-if="!readonly">
      <v-btn :disabled="loading" @click="addAll()" variant="text" color="blue"
        ><v-icon class="mr-2">mdi-table-arrow-right</v-icon> Adicionar
        todos</v-btn
      >
      <v-btn :disabled="loading" @click="removeAll()" variant="text" color="error"
        ><v-icon class="mr-2">mdi-backspace</v-icon> Remover todos</v-btn
      >
    </v-col>
    <v-col cols="12" class="text-right my-0 py-0" v-if="!readonly">
      <v-btn :disabled="loading" @click="$emit('updated', list_to)" variant="text" color="success"
        ><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn
      >
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    title: String,
    listFrom: Array,
    listFromKey: String,
    listTo: Array,
    listToKey: String,
    bigList: Boolean,
    loading: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      list_from: [],
      list_to: [],
    };
  },
  created() {
    var vm = this;
    vm.list_from = vm.listFrom || [];
    vm.list_to = vm.listTo || [];
    vm.validateList();
  },
  mounted() {},
  activated() {},
  methods: {
    addItem(item, index) {
      var vm = this;
      if (vm.loading) {
        return
      }
      vm.list_to.push(item);
      vm.list_from.splice(index, 1);
    },
    addAll() {
      var vm = this;
      vm.list_to.push(...vm.list_from);
      vm.list_from = [];
    },
    removeAll() {
      var vm = this;
      vm.list_from.unshift(...vm.list_to);
      vm.list_to = [];
    },
    removeItem(item, index) {
      var vm = this;
      if (vm.loading || vm.readonly) {
        return
      }
      vm.list_to.splice(index, 1);
      vm.list_from.unshift(item);
    },
    validateList() {
      var vm = this;
      vm.list_to.forEach((lp_to) => {
        let _ix_lp_from = vm.list_from.findIndex((x) => x.id === lp_to.id);
        if (_ix_lp_from >= 0) {
          vm.list_from.splice(_ix_lp_from, 1);
        }
      });
    },
  },
  watch: {
    listFrom(newList) {
      var vm = this
      vm.list_from = newList || []
      vm.validateList()
    },
    listTo(newList) {
      var vm = this;
      vm.list_to = newList || [];
      vm.validateList();
    },
  },
};
</script>